import routeTitles from '../const/routeTitles';
import getUrlInfo from './mini/getUrlInfo';
import history from '../history';
import { routeInfo } from '../routeInfo';
import { IProject } from '../models/IProject';
import isLocalStorageAvailable from '../services/mini/isLocalStorageAvailable';

let _history = [];

function getLastSelectedPathKey(projectName: string) {
    return `alan-last-selected-path-${projectName}`;
}

const HistoryKeeper = {
    clean: function () {
        _history = [];
    },
    push: function (path?: string) {
        const pathname = path || window.location.pathname;
        if (_history[_history.length - 1] !== pathname.substring(1, pathname.length)) {
            _history.push(pathname.substr(1, pathname.length));
        }
    },
    setLastSelectedScript: function (path: string, projectName: string) {
        if (path && projectName && isLocalStorageAvailable()) {
            localStorage.setItem(getLastSelectedPathKey(projectName), path.substr(1, path.length));
        }
    },
    getPrevLocation: function () {
        const goToUrl = _history[_history.length - 2];
        const urlInfo = getUrlInfo(goToUrl);

        if (goToUrl) {
            if (goToUrl === routeTitles.settings.path) {
                return routeTitles.settings;
            } else if (goToUrl.indexOf(routeTitles.billing.path) === 0) {
                return routeTitles.billing;
            } else if (urlInfo && urlInfo.projectName) {
                return {
                    isProject: true,
                    path: goToUrl,
                    title: urlInfo.projectName
                };
            }
        }
        return null;
    },
    getBackPath: function (goToProject?: boolean) {
        let pathname = window.location.pathname;
        pathname = pathname.substring(1, pathname.length);
        const prevHistoryItem = _history.pop();
        const {
            projectName,
            scriptName,
            page,
            isTestMode
        } = getUrlInfo(pathname);

        if (page === 'compare' ||
            page === 'embed' ||
            page === 'analytics' ||
            page === 'corpus' ||
            (page === 'project' && isTestMode)) {
            _history.pop();
            return scriptName ? routeInfo.projectScripts.url(projectName, scriptName) : routeInfo.project.url(projectName);
        } else {
            const goToUrl = _history[_history.length - 1];
            _history.pop();

            if (goToProject === true) {
                return routeInfo.projects.url();
            }

            if (goToUrl) {
                return goToUrl;
            } else {
                return routeInfo.projects.url();
            }
        }
    },
    goBack: function (project?: IProject) {
        let pathname = window.location.pathname;
        pathname = pathname.substring(1, pathname.length);
        const { scriptName } = getUrlInfo(pathname);
        if (project && isLocalStorageAvailable()) {
            const projectName = project.name;
            const _lastSelectedScriptPath = localStorage.getItem(getLastSelectedPathKey(projectName));
            let isTransform = false;
            project.scripts.forEach(script => {
                if (script.name === scriptName && script.type === 'transform') {
                    isTransform = true;
                }
            });
            if (isTransform && _lastSelectedScriptPath) {
                history.push(_lastSelectedScriptPath);
                return;
            }
            if (!isTransform && project.scripts?.length > 0) {
                history.push(HistoryKeeper.getBackPath(true));
                return;
            }
        }
        history.push(HistoryKeeper.getBackPath());
    }
};

export default HistoryKeeper;

